const styles = (theme) => ({
  header: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.AppBGColor}`,
  },
  checkBoxContainer: {
    display: "flex",
    padding: "8px 8px 8px 0px",
  },
  checkBoxLabelContainer: {
    display: "flex",
    flexDirection: "column",
    color: theme.TextColor,
  },
  title: {
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    color : theme.ColumnHeaderTextColor,
  },
  subTitle: {
    fontSize: theme.textFontSize,
  },
  divider: {
    backgroundColor: theme.gridIconBorderColor,
    opacity: 0.6,
    margin: 4,
  },
  redButton: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",
    marginLeft: 24,
    background: theme.ErrorMessageColor,
    color: theme.white,
    "&$disabledButton": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8
    },
    width: "50%",
  },
  disabledButton: {},
  content: {
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
  },
  actionContainer: {
    padding: "16px 16px 48px 16px",
    display : "flex",
    justifyContent : "flex-end"
  },
  icon: {
    color: theme.iconColor,
  },
  headerText: {
    display : "flex",
    flexDirection : "column",
    padding : "8px 0px 8px 0px",
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
  },
  headerLabelContainer: {
    display: "flex",
    alignItems: "center",
  },
  circularProgress: {
    color: theme.white,
  },
  accountLabel : {
    fontSize : theme.textFontSize,
    fontWeight : 600,
    color : theme.ColumnHeaderTextColor
  }
});

export default styles;
